
import { apiProductsProvider } from "./apiProductsProvider";
import { mockProductsProvider } from "./mockProductsProvider";
import { isMockEnabled } from "../../../config/featureConfig";

export const productsProvider = isMockEnabled("products")
  ? mockProductsProvider
  : apiProductsProvider;

